import { HammerGestureConfig } from '@angular/platform-browser';
import hammer from 'hammerjs';
import $ from 'jquery';
import { Injectable } from '@angular/core';

/**
 * Used to use pan in all directions.
 */
@Injectable({
    providedIn: 'root'
})
export class CustomHammerConfig extends HammerGestureConfig {

    touchActionVal = 'pan-y pan-x';

    overrides = {
        // override hammerjs default configuration
        pan: { threshold: 5, direction: hammer.DIRECTION_ALL },
        pinch: { enable: true },
        touchAction: this.touchActionVal
    } as any;

    buildHammer(element: HTMLElement): any {
        const isTouchDevice = $('html')
            .hasClass('touchevents');

        let myHammer;
        if (isTouchDevice) {
            myHammer = new hammer(element, {
                // Be careful when changing this settings!
                // Might break Interaction on special devices like laptops with Touchevents in specific browsers.
                inputClass: hammer.TouchMouseInput,
                pinch: { enable: true },
                touchAction: this.touchActionVal,
                domEvents: true
            });
        } else {
            myHammer = new hammer(element, {
                pinch: { enable: true },
                domEvents: true
            });
        }
        myHammer.get('pinch')
            .set({
                enable: true
            });

        return myHammer;
    }
}
